const FontFamily = "";

const getFontFamily = () => {
  return FontFamily ?? "san-serif";
};

export { getFontFamily };
